module.exports = "data:image/webp;base64,UklGRj4BAABXRUJQVlA4TDEBAAAvHMAGEJ9hmI2kkgzT+T8X5SgIsm1KNvjTHIMg26Yuwzr7XRi2jaQ4Nbj3DGUA7tM60RbW2/I6W7NOqJV1t2Y9La4T0+K6W1g/W1hfSEvrA7XudbWAA4MDG4gfxycUgx0bimLHoBAKh5Fkm9Y+2/a3ffLP7fHe/zKI6H9i6WKVb2KNkmBViVU5ZmZpY+kGWCQYxSoH0ywrDZONwawU8KQsjzA38JekYaWz87DmTveNhb9EDB2Nl1oFN4kw6D+afqdCBstuDExHWrwPqYB5lmCeEuu19zAqIhbCg9j3jQXmhjg3B0z9R6zvRgDnRIybA25KjIcFrvAkxssBd0ustwee/qPhQ/NPDN6ZhnZL8xt4BfVXoT/TdFPBE14/D736pOEig7/tMYZfOsn4Q5cxtUcBAwA="


//////////////////
// WEBPACK FOOTER
// ./static/website/images/search-arrow.webp
// module id = KGc3
// module chunks = 0